import { render, staticRenderFns } from "./PorFiltroDeDataInicialEFinal.vue?vue&type=template&id=0bdab216"
import script from "./PorFiltroDeDataInicialEFinal.vue?vue&type=script&setup=true&lang=js"
export * from "./PorFiltroDeDataInicialEFinal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports